/**
 * Catalog category identifiers, reached on the eager boot path: route registration
 * (`views-catalog`'s routing), the publications DTO mappers and the legacy catalog modules all
 * compare against these enum members.
 *
 * Kept in an import-free leaf module: anything this file imports ships in the eager `app` bundle
 * alongside it, and the rest of the catalog type surface in `./types.ts` — sort orders, layout
 * modes, release frequencies and their lookup maps — is consumed only from lazily-loaded chunks.
 */

enum CategoryGroupName {
    Countries = 'Countries',
    Languages = 'Languages',
    PublicationTypes = 'PublicationTypes',
    Categories = 'BaseContentCatalog',
}

enum Category {
    // client-specific categories
    Undefined = '',
    Favorites = 'mypublications',
    TopMagazines = 'topmagazines',
    MagazinesSlug = 'magazines',
    TopNewspapers = 'topnewspapers',
    NewspapersSlug = 'newspapers',
    OnlineEditionsSlug = 'online-editions',
    PDFBooksSlug = 'pdfbooks',
    TopPublications = 'toppublications',
    TopFree = 'topfreepublications',
    Featured = 'featured',
    RecentlyRead = 'recentlyread',
    All = 'all',
    Trial = 'trial', // DEPRECATED
    FeaturedHotspot = 'featuredhotspot',
    Books = 'books',
    BooksGenres = 'genres',
    BooksSpecialCollection = 'special_collection',
    BooksAuthors = 'authors',
    BooksSeries = 'series',
    BaseContent = 'basecontent',
    Publications = 'publications',
    BooksMyBooks = 'library',
    NationalNews = 'national',
    LocalNews = 'local',
    PopularWorldwide = 'international',
    PopularInCountry = 'popular-in-country',
    Free = 'free',
    MostPopular = 'mostpopular',
    Archives = 'archives',
    STS = 'sts',
    Daily = 'daily',
    Weekly = 'weekly',
    Sunday = 'sunday',
    Today = 'today',

    Countries = 656,
    Languages = 1032,
    Categories = 584,
    PublicationTypes = 8388608,
    Magazines = 150994944,
    Newspapers = 142606336,
    OnlineEditions = 201326592,
    PDFBooks = 164071058,
    International = 938,
    News = 1124,
    BusinessFinance = 1069,
    Sports = 1075,
    ArchivedNewspapers = 2724,
    ArchivedMagazines = 2725,
    STSNewspapers = 2726,
    STSMagazines = 2727,
}

export { Category, CategoryGroupName };
